import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { GroupDetailPage } from '@/features/groups/components';

function GroupDetailRoute(): ReactNode {
  const { slug } = Route.useParams();
  return <GroupDetailPage slug={slug} />;
}

export const Route = createFileRoute('/groups/$slug')({
  component: GroupDetailRoute,
});
